"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerValidationStrategyObject = exports.ToneOfVoiceObject = exports.isBorderTemplate = exports.borderTemplates = exports.isBorder = exports.Position = void 0;
exports.Position = {
    DEFAULT: 'DEFAULT',
    ELEMENT: 'ELEMENT',
    LAUNCHER: 'LAUNCHER',
    OVERLAY: 'OVERLAY',
    SIDEBAR: 'SIDEBAR',
    SIBLING: 'SIBLING',
};
function isBorder(item) {
    if (item.main === '0px' &&
        item.components === '0px' &&
        item.chips === '4px') {
        return true;
    }
    else if (item.main === '0.5rem' &&
        item.components === '0.25rem' &&
        item.chips === '4px') {
        return true;
    }
    else if (item.main === '1rem' &&
        item.components === '0.5rem' &&
        item.chips === '0.25rem') {
        return true;
    }
    else {
        return false;
    }
}
exports.isBorder = isBorder;
exports.borderTemplates = {
    square: {
        main: '6px',
        components: '4px',
        innerComponents: '2px',
    },
    default: {
        main: '12px',
        components: '8px',
        innerComponents: '4px',
    },
    round: {
        main: '16px',
        components: '12px',
        innerComponents: '8px',
    },
};
function isBorderTemplate(borderTemplate) {
    return borderTemplate in exports.borderTemplates;
}
exports.isBorderTemplate = isBorderTemplate;
exports.ToneOfVoiceObject = {
    formal: 'formal',
    informal: 'informal',
};
exports.AnswerValidationStrategyObject = {
    progressive: 'progressive',
    conservative: 'conservative',
};
exports.default = {};
